import { appendChildren, createElement } from '../../adapters/dom';
import { createMethodCard } from '../components/method-card';
import type { WidgetSessionResponse } from '../../types/state';

export interface MethodSelectTemplateOptions {
  session: WidgetSessionResponse;
  onSelect: (methodCode: string) => void;
}

export function createMethodSelectTemplate(
  options: MethodSelectTemplateOptions
): HTMLDivElement {
  const wrapper = createElement('div', {
    className: 'cpw-screen cpw-screen-method-select'
  }) as HTMLDivElement;

  const title = createElement('h3', {
    className: 'cpw-title',
    textContent: 'Выберите способ оплаты'
  });

  const description = createElement('p', {
    className: 'cpw-text',
    textContent: 'Доступные сети и активы для этого заказа'
  });

  const list = createElement('div', {
    className: 'cpw-methods-list'
  }) as HTMLDivElement;

  const methodCards = options.session.availableMethods.map((methodCode) =>
    createMethodCard({
      method: {
        methodCode,
        displayName: methodCode.replace(/_/g, ' / ')
      },
      onSelect: options.onSelect
    })
  );

  appendChildren(list, methodCards);
  wrapper.append(title, description, list);

  return wrapper;
}